import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { installDevTitlePrefix } from "./lib/devTitlePrefix";
import { captureFirstTouch } from "./lib/firstTouch";
import { captureInstallPrompt } from "./lib/pwaInstall";
import { registerServiceWorker } from "./lib/webPush";

installDevTitlePrefix();
captureFirstTouch();
captureInstallPrompt();
registerServiceWorker();

Sentry.init({
  dsn: "https://ecdb49ecaf004c52990757d0402ecba7@o4511040189693952.ingest.us.sentry.io/4511040357990400",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0.2,
  replaysOnErrorSampleRate: 1.0,
  // Drop noise from third-party in-app browsers (Meta IAB / Instagram /
  // Facebook / Threads, ByteDance). These errors fire inside the host app's
  // injected JS and there is nothing for us to fix.
  ignoreErrors: [
    /Java object is gone/i,
    /enableDidUserTypeOnKeyboardLogging/i,
    /sendBeforeUnloadMessage/i,
  ],
  denyUrls: [
    /iabjs:\/\//i,
    /webview\.bytedance\.com/i,
  ],
});

createRoot(document.getElementById("root")!).render(<App />);
